// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\SectionHeader.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\SectionHeader.tsx");
  import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

import { cn } from "~/lib/utils";
export function SectionHeader({
  title,
  eyebrow,
  className = "",
  layout = "horizontal"
}) {
  console.log(layout, title);
  const layoutClasses = layout === "vertical" ? "flex flex-col gap-3 lg:gap-4" : "flex flex-col lg:flex-row lg:items-end gap-3 lg:gap-6";
  return <div className={`${layoutClasses} ${className}`}>
      {eyebrow && <div className="flex items-center gap-2">
          <span className="text-button-small lg:text-base leading-4 lg:leading-5 tracking-[0.02em] uppercase text-neutral-900/60 whitespace-nowrap">
            [{eyebrow}]
          </span>
        </div>}
      <h2 className={cn("text-heading-5 lg:text-[68px] leading-[100%] font-medium tracking-[-0.03em] uppercase text-neutral-900 ", layout === "horizontal" ? "ml-6" : "ml-0", eyebrow ? "" : "!ml-0", className)}>
        {title}
      </h2>
    </div>;
}
_c = SectionHeader;
var _c;
$RefreshReg$(_c, "SectionHeader");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;